export default "__VITE_ASSET__CPws4mhT__"